<div class="overLayDiv active"></div>
<div id="rightSideBar">
  <form [formGroup]="foreignCurrencyForm" novalidate>
    <div class="rightSidePanel active" style="z-index: 99999;">
      <header class="panel-header">
        <div class="viewDemo title-and-video">
          <h2>{{ "select_currency" | translate: param }}</h2>
        </div>
        <div class="panel-left-btn">

          <button type="button" class="btn eod-btn-primary mr-2"
            [ngClass]="{'disabled':  disableSubmitButton || !this.foreignCurrencyForm.dirty}"
            (click)="fnSubmitForeignCurrency()">
            {{ 'label_save' | translate: param }}
          </button>
          <button type="button" class="btn eod-btn-outline-warning" (click)="fnClosePanel()">
            {{ 'label_close' | translate: param }}
          </button>

        </div>
      </header>
      <div class="eod-panle-body">
        <div class="block bg-transparent shadow-0 py-3" [hidden]="!btnresetForeignCurrencyDisplay">
          <div class="preapproval-badge d-flex justify-content-between align-items-center p-3 gap-5">
            <h6 class="m-0">
              {{ 'fx_rate_msg1' | translate: param }} <span class="fw-700">{{selectedCurrencyCode}}</span>
              {{ 'fx_rate_msg2' | translate: param }}
              <span class="fw-700">{{ 'fx_rate_msg3' | translate: param }}</span>
            </h6>
            <button type="button" class="btn eod-bg-primary" (click)="resetForeignCurrencyForm()">{{ 'fx_rate_msg4' |
              translate: param }} {{baseCurrencyCode}}</button>
          </div>
        </div>
        <div class="block mt-0">
          <div class="row margin-top-20">
            <div class="col-lg-6 pr-2 pl-0 d-flex flex-column justify-content-end">
              <div class="input-group disabled">
                <span class="position-absolute left-0px top-3px" *ngIf="inputData.baseCurrencyIcon">
                  <img src="{{baseCurrency.icon}}" alt="" class="position-relative w-30px height-30px z-9999">
                </span>
                <input type="text" class="form-control text-ellipsis-approver
                 has-value padding-left-35 color-light-grey-disabledType" formControlName="currencyCode" [ngClass]="{
                    'has-value': foreignCurrencyForm.controls.currencyCode.value
                  }" />

                <label for="ExpenseCategory">{{ "base_currency" | translate: param }}
                </label>

                <div *ngIf="
                    foreignCurrencyForm.controls.currencyCode.invalid &&
                    isForeignCurrencyFormSubmitted
                  " class="alert-danger">
                  <span *ngIf="
                      foreignCurrencyForm.controls.currencyCode.errors
                        .required ||
                      foreignCurrencyForm.controls.currencyCode.value.trim() ==
                        ''
                    ">
                    <b>{{ "label_Required" | translate: param }}</b>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-lg-6 pr-0 pl-2">
              <div class="input-group"
                [ngClass]="{'disabled': inputData?.exchangeRateSource == ExchangeRateSource.Statement }">
                <ng-select class="solo-dropdown filterDropdown" [items]="foreignCurrencyList"
                  bindLabel="currencyDescription" bindValue="currencyId" formControlName="spentCurrencyId" (change)="
                    fnGetSpentCurrencyCode(
                      foreignCurrencyForm.controls.spentCurrencyId.value
                    )
                  " placeholder="Spent Currency" [selectOnTab]="true"
                  notFoundText="{{ 'no_data_available' | translate: param }}" required-field [clearable]="false"
                  [clearOnBackspace]="false">
                  <ng-template ng-label-tmp let-item="item">
                    <img alt="icon" class="height-20px" [src]="item.icon" />
                    {{ item.currencyDescription }}
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div>
                      <img alt="icon" class="height-20px" src="{{ item.icon }}" />&nbsp;&nbsp;
                      {{ item.currencyDescription }}
                    </div>
                  </ng-template>
                </ng-select>
                <div *ngIf="
                    foreignCurrencyForm.controls.spentCurrencyId.invalid &&
                    isForeignCurrencyFormSubmitted
                  " class="alert-danger">
                  <div *ngIf="foreignCurrencyForm.controls.spentCurrencyId.invalid">
                    <b>{{ "label_Required" | translate: param }}</b>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 pr-2 pl-0 mt-4">
              <div class="input-group"
                [ngClass]="{' disabled': inputData?.exchangeRateSource == ExchangeRateSource.Statement }">
                <input type="text" class="form-control has-value searchField" (input)="onRateChange()"
                  [readonly]="fxRateRule == FxRateRule.NotEditable && foreignCurrencyForm.controls.conversionRate.value>1"
                  sixDigitBeforeAndAfterDecimalNumber formControlName="conversionRate" [ngClass]="{
                    'has-value':
                      foreignCurrencyForm.controls.conversionRate.value
                  }">
                <label for="ExpenseCategory">{{ "rate" | translate: param }}<span>*</span>
                </label>

                <div *ngIf="
                    foreignCurrencyForm.controls.conversionRate.invalid &&
                    isForeignCurrencyFormSubmitted
                  " class="alert-danger">
                  <span *ngIf="
                      foreignCurrencyForm.controls.conversionRate.errors
                        .required ||
                      foreignCurrencyForm.controls.conversionRate.value.trim() ==
                        ''
                    ">
                    <b>{{ "label_Required" | translate: param }}</b>
                  </span>
                </div>
              </div>
              <div>
                <div class="f-11 info-text text-primary d-block text-right"
                  *ngIf="inputData?.exchangeRateSource == ExchangeRateSource.Live">
                  <i class="fas fa-info-circle text-primary pr-1"></i>
                  <span>{{ 'live_exchange_rate' |
                    translate }}</span>
                </div>
                <div class="f-11 info-text text-primary d-block  text-right"
                  *ngIf="inputData?.exchangeRateSource == ExchangeRateSource.Statement">
                  <i class="fas fa-info-circle text-primary pr-1"></i>
                  <span>{{ 'exchange_rate_statement' | translate }}</span>
                </div>
                <div class="f-11 info-text text-primary d-block  text-right"
                  *ngIf="inputData?.exchangeRateSource == ExchangeRateSource.Manual">
                  <i class="fas fa-info-circle text-primary pr-1"></i>
                  <span>{{ 'manual_exchange_rate' |
                    translate }}</span>
                </div>
              </div>
              <!-- <div class="ai-scanned-label">
                <img src="../../../../../assets/svg-icons/ai.svg" alt="ai" class="required-icon">
                <span>{{ 'ai_scanned_value' | translate }}</span>
              </div> -->
            </div>
          </div>
        </div>
        <div class="block padding-top-15" *ngIf="
            foreignCurrencyForm.controls.conversionRate.value > 0 &&
            foreignCurrencyForm.controls.spentCurrencyId.value > 0
          ">
          <h6 class="border-bottom padding-bottom-10">
            {{ "exchange_rates" | translate: param }}
          </h6>
          <div class="row">
            <div class="col-lg-12 no-padding-right-left">
              <span class="position-absolute left-0px top-3px"><i
                  class="fas fa-info-circle text-mustard f-16"></i></span>
              <div class="padding-left-30">
                <p class="w-100pc">
                  <span class="d-inline-block padding-right-18 f-14 w-35pc">
                    {{ this.devideValue }}
                    {{ foreignCurrencyForm.controls.currencyCode.value }}</span>=<span class="
                      d-inline-block
                      w-50pc
                      padding-left-30
                      fw-700
                      text-right
                    ">{{ this.fnCalculateConversionRates() }}
                    {{
                    foreignCurrencyForm.controls.spentCurrencyCode.value
                    }}</span>
                </p>
                <p class="w-100pc">
                  <span class="d-inline-block padding-right-15 f-14 w-35pc">{{ this.devideValue }}
                    {{
                    foreignCurrencyForm.controls.spentCurrencyCode.value
                    }} </span>=<span class="
                      d-inline-block
                      w-50pc
                      padding-left-30
                      fw-700
                      text-right 
                    ">{{ foreignCurrencyForm.controls.conversionRate.value }}
                    {{ foreignCurrencyForm.controls.currencyCode.value }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="block color-red" [hidden]="fxRateRule ==FxRateRule.Default">
          <h6 class="note eod-text-danger">{{ "disclaimer" | translate: param }}:</h6>
          <h6 class="info-text">
            <i class="fas fa-exclamation-circle eod-text-danger"></i>
            <span class="eod-text-danger">{{ "disclaimer_msg" | translate: param }}</span>
          </h6>
        </div>
        <div class="block bg-transparent shadow-0 pt-0">
          <div class="bg-white border padding-15 border-primary box-shadow">
            <h6 class="fw-700 mb-2">
              ** {{ "currency_reminder" | translate: param }} **
            </h6>
            <p class="mb-2 lH-20">
              {{ "currency_text1" | translate: param }}
            </p>
            <p class="fw-700">{{ "thanks" | translate: param }}</p>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>